// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__xkqUX","tooltip_position_center":"tooltip_tooltip_position_center__Utv9F","tooltip_visible":"tooltip_tooltip_visible__NcYtx"};